<div class="notfound-container">
  <div class="error-content">
    @if (companyLogo) {
      <img class="brand-logo" [src]="companyLogo" [alt]="companyName || 'Logo'" />
    }

    <div class="error-code">404</div>

    <h1 class="error-title">Pagina non trovata</h1>

    <p class="error-message">
      La pagina che stai cercando non esiste o è stata spostata. Controlla l'indirizzo oppure torna alla home.
    </p>

    <div class="action-buttons">
      <button class="kcs-btn kcs-btn-primary" (click)="goHome()">
        <i class="pi pi-home" aria-hidden="true"></i> Torna alla home
      </button>
      <button class="kcs-btn kcs-btn-secondary" (click)="goBack()">
        <i class="pi pi-arrow-left" aria-hidden="true"></i> Indietro
      </button>
    </div>
  </div>
</div>
